// extracted by mini-css-extract-plugin
export default {"placeholder":"product-detail_placeholder__gHrdA","container":"product-detail_container__4mRj1","productDetail":"product-detail_productDetail__SpALY"};